import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Spinner } from "@/components/ui/spinner";
import { TarotDeckHandler, TarotDeckHandlerContext } from "@/lib/deck";
import { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router";
import "../index.css";

function InitializedRoot({ deckHandler }: { deckHandler: TarotDeckHandler }) {
	useEffect(() => {
		window.Telegram.WebApp.expand();
	}, []);

	return (
		<TarotDeckHandlerContext value={deckHandler}>
			<div className="pb-12">
				<div>
					<DropdownMenu>
						<div className="fixed bottom-6 left-4 z-50">
							<DropdownMenuTrigger asChild>
								<Button
									variant="outline"
									className="text-xl border-amber-900/40 bg-amber-100 bg-amber-100/70 text-amber-900 backdrop-blur-sm rounded-full py-6"
								>
									<span>🎴</span>
									Меню
								</Button>
							</DropdownMenuTrigger>
						</div>
						<DropdownMenuContent>
							<DropdownMenuGroup>
								<DropdownMenuLabel className="text-sm text-gray-400">
									Расклады
								</DropdownMenuLabel>
								<NavLink to="/three-cards">
									<DropdownMenuItem className="text-md">
										Три карты
									</DropdownMenuItem>
								</NavLink>
							</DropdownMenuGroup>
							<DropdownMenuSeparator />
							<NavLink to="/card-of-the-day">
								<DropdownMenuItem className="text-md">
									Карта дня
								</DropdownMenuItem>
							</NavLink>
							<DropdownMenuSeparator />
							<DropdownMenuGroup>
								<DropdownMenuLabel className="text-sm text-gray-400">
									Мой аккант
								</DropdownMenuLabel>
								<DropdownMenuItem disabled className="text-md">
									Настройки
								</DropdownMenuItem>
							</DropdownMenuGroup>
						</DropdownMenuContent>
					</DropdownMenu>
				</div>
				<Outlet />
			</div>
		</TarotDeckHandlerContext>
	);
}

export function Root() {
	const [deckHandler, setDeckHandler] = useState<TarotDeckHandler>();
	useEffect(() => {
		window.Telegram.WebApp.expand();

		TarotDeckHandler.create(
			(deckHandler) => {
				setDeckHandler(deckHandler);

				deckHandler.meta.then((deckMeta) => {
					fetch("/api/registerDeck", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Authorization: `tma ${window.Telegram.WebApp.initData}`,
						},
						body: JSON.stringify(deckMeta),
					});
				});
			},
			() => {
				alert(
					"У вас открыто несколько окон вашей колоды. Эта вкладка будет закрыта!",
				);
				window.Telegram.WebApp.close();
				throw new Error("No deck!");
			},
		);
	}, []);

	if (!deckHandler)
		return (
			<div className="z-11 absolute top-0 bottom-0 left-0 right-0 inset-0 bg-white/70 flex items-center justify-center">
				<Spinner className="size-48 center" />
			</div>
		);

	return <InitializedRoot deckHandler={deckHandler} />;
}
